(() => {
    const RETOOL_SERIAL_URL = 'https://vorwerkturkey.retool.com/url/serial-number-validation';
    const MECHANIC_EARNING_COMPLETE_URL = 'https://webhooks.mechanic.dev/922c81e4-49ac-410b-80a8-2cdc67152c9d';
    const SERIAL_LENGTH = 17;
    const FORMAT_ERROR_ID = 'newcomer-step3-serial-format-error';
    const FALLBACK_ERROR_ID = 'newcomer-step3-serial-error';
    const SUCCESS_ID = 'newcomer-step3-serial-success';
    const EARNING_SUCCESS_ID = 'newcomer-step3-earning-success';
    const MISSING_PARAMETER_ID = 'newcomer-step3-missing-parameter';
    const NEWCOMER_PRODUCT_PARAM = 'newcomer_product';

    const root = document.querySelector('[data-newcomer-step3]');
    if (!root) return;

    const serialPanel = root.querySelector('[data-step3-serial-panel]');
    const buyPanel = root.querySelector('[data-step3-buy-panel]');
    const serialInput = root.querySelector('[data-step3-serial]');
    const productError = root.querySelector('[data-step3-product-error]');
    const statusList = root.querySelector('[data-step3-status]');
    const questions = root.querySelector('[data-step3-questions]');
    const currentProgress = root.querySelector('[data-step3-current-progress]');
    const ownerProgress = root.querySelector('[data-step3-owner-progress]');
    const checkSerialButton = root.querySelector('[data-step3-check-serial]');
    const ownershipRadios = root.querySelectorAll('input[name="newcomer_step3_has_tm7"]');
    const purchaseRadios = root.querySelectorAll('input[name="newcomer_step3_buy_tm7"]');
    const loader = document.querySelector('.jsc-loader-overlay');

    const scrollToElement = (target) => {
        if (!target) return;

        const headerOffset = 250;
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth'
        });
    };

    const hideError = (element) => {
        if (!element) return;
        element.hidden = true;
        element.style.display = 'none';
    };

    const hideStatus = () => {
        if (!statusList) return;

        statusList.hidden = true;
        statusList.style.display = 'none';
        statusList.classList.remove('newcomer-step3__status--success');

        for (const item of statusList.querySelectorAll('li')) {
            item.hidden = true;
            item.style.display = 'none';
        }
    };

    const parseStatusIds = (message) => {
        if (typeof message !== 'string') return [];

        return message.split(',').map((id) => id.trim()).filter(Boolean);
    };

    const showStatusItem = (id) => {
        const item = document.getElementById(id);
        if (!item || !statusList?.contains(item)) return false;

        item.hidden = false;
        item.style.display = 'list-item';
        return true;
    };

    const showStatus = (ids, { success = false } = {}) => {
        if (!statusList) return;

        hideStatus();

        const requestedIds = ids.length > 0 ? ids : [success ? SUCCESS_ID : FALLBACK_ERROR_ID];
        let shown = 0;

        for (const id of requestedIds) {
            if (showStatusItem(id)) shown += 1;
        }

        if (shown === 0) {
            showStatusItem(success ? SUCCESS_ID : FALLBACK_ERROR_ID);
        }

        if (success) {
            statusList.classList.add('newcomer-step3__status--success');
        }

        statusList.hidden = false;
        statusList.style.display = 'block';
        scrollToElement(statusList);
    };

    const showOwnerProgress = () => {
        if (currentProgress) currentProgress.hidden = true;
        if (ownerProgress) ownerProgress.hidden = false;
    };

    const setLoading = (isLoading) => {
        if (checkSerialButton) {
            checkSerialButton.disabled = isLoading;
            checkSerialButton.classList.toggle('disabled', isLoading);
        }

        for (const radio of [...ownershipRadios, ...purchaseRadios]) {
            radio.disabled = isLoading;
        }

        if (loader) loader.style.display = isLoading ? 'block' : 'none';
    };

    const resetPurchaseChoice = () => {
        for (const radio of purchaseRadios) {
            radio.checked = false;
        }

        hideError(productError);
    };

    const isVisible = (element) => Boolean(element) && getComputedStyle(element).display !== 'none';

    const hideStep = (element) => {
        if (!element) return;
        element.hidden = true;
        element.style.display = 'none';
    };

    const applicationStore = () => window.jscNewcomerApplication;

    const rememberApplicationStep = (step) => {
        const application = applicationStore();
        const customerId = root.dataset.customerId || '';

        if (!application || !customerId) return;

        if (root.dataset.applicationFinished === 'true') {
            application.remove(customerId);
            return;
        }

        const program = root.dataset.newcomerProgram === 'owner' ? 'owner' : 'earning';
        application.write(customerId, program, step);
    };

    const clearApplication = () => {
        const application = applicationStore();
        const customerId = root.dataset.customerId || '';

        if (!application || !customerId) return;

        application.remove(customerId);
    };

    const showStep3 = ({ scroll = false } = {}) => {
        const application = applicationStore();

        if (application?.show) {
            application.show('3');
        } else {
            const step2a = document.querySelector('.step2a');
            const step2b = document.querySelector('.step2b');

            if (!isVisible(step2b)) return;

            hideStep(step2a);
            hideStep(step2b);
            root.hidden = false;
            rememberApplicationStep('3');
        }

        if (scroll) scrollToElement(root);
    };

    const completeEarningProgram = async () => {
        const customerId = root.dataset.customerId || '';

        if (!customerId) {
            resetPurchaseChoice();
            showStatus([MISSING_PARAMETER_ID]);
            return;
        }

        setLoading(true);

        try {
            if (MECHANIC_EARNING_COMPLETE_URL.includes('REPLACE_WITH_')) {
                throw new Error('The earning program Mechanic webhook URL has not been configured.');
            }

            const response = await fetch(MECHANIC_EARNING_COMPLETE_URL, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({
                    customer_id: customerId
                })
            });

            let result = {};

            try {
                result = await response.json();
            } catch {
                result = {};
            }
            console.log("response: ", response);

            const ids = parseStatusIds(result.message);
            const isSuccess = response.ok && result.status !== 'fail';

            if (isSuccess) {
                clearApplication();
                hideStep(questions);
                showStatus(ids.length > 0 ? ids : [EARNING_SUCCESS_ID], { success: true });
                return;
            }

            resetPurchaseChoice();
            showStatus(ids.length > 0 ? ids : [FALLBACK_ERROR_ID]);
        } catch (error) {
            console.error(error);
            resetPurchaseChoice();
            showStatus([FALLBACK_ERROR_ID]);
        } finally {
            setLoading(false);
        }
    };

    const redirectToEarningProduct = () => {
        const productUrl = root.dataset.earningProductUrl;

        if (!productUrl) {
            if (productError) {
                productError.hidden = false;
                productError.style.display = 'block';
                scrollToElement(productError);
            }
            return;
        }

        rememberApplicationStep('3');

        const destination = productUrl.startsWith('/') && window.theme?.urls
            ? window.theme.urls.toStoreUrl(productUrl.replace(/^\/+/, ''))
            : productUrl;
        const productLink = new URL(destination, window.location.origin);
        const productId = root.dataset.earningProductId;

        if (productId) productLink.searchParams.set(NEWCOMER_PRODUCT_PARAM, productId);

        window.location.href = productLink.toString();
    };

    for (const radio of ownershipRadios) {
        radio.addEventListener('change', () => {
            hideStatus();
            serialPanel.hidden = radio.value !== 'yes';
            buyPanel.hidden = radio.value !== 'no';

            if (radio.value === 'yes') {
                resetPurchaseChoice();
                serialInput?.focus();
            } else if (serialInput) {
                serialInput.value = '';
            }
        });
    }

    for (const radio of purchaseRadios) {
        radio.addEventListener('change', () => {
            hideError(productError);

            if (radio.value === 'yes') {
                redirectToEarningProduct();
                return;
            }

            completeEarningProgram();
        });
    }

    serialInput?.addEventListener('input', () => {
        serialInput.value = serialInput.value.replace(/\D/g, '').slice(0, SERIAL_LENGTH);
        hideStatus();
    });

    checkSerialButton?.addEventListener('click', async () => {
        const serialNumber = serialInput?.value.trim() || '';
        const email = root.dataset.customerEmail || '';

        if (serialNumber.length !== SERIAL_LENGTH) {
            showStatus([FORMAT_ERROR_ID]);
            serialInput?.focus();
            return;
        }

        setLoading(true);

        try {
            if (RETOOL_SERIAL_URL.startsWith('REPLACE_WITH_')) {
                throw new Error('The serial Retool webhook URL has not been configured.');
            }

            const response = await fetch(RETOOL_SERIAL_URL, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({
                    serial_number: serialNumber,
                    email
                })
            });

            let result = {};

            try {
                result = await response.json();
            } catch {
                result = {};
            }

            const ids = parseStatusIds(result.message);
            const isSuccess = response.ok && result.status === 'success';

            if (isSuccess) {
                clearApplication();
                hideStep(questions);
                showStatus(ids, { success: true });
                showOwnerProgress();
                return;
            }

            showStatus(ids);
        } catch (error) {
            console.error(error);
            showStatus([FALLBACK_ERROR_ID]);
        } finally {
            setLoading(false);
        }
    });

    document.addEventListener('jsc:newcomer-step2-complete', () => {
        showStep3({ scroll: true });
    });

    const resumeOwnershipStep = () => {
        if (new URLSearchParams(window.location.search).get('step') !== '3') return;
        showStep3();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', resumeOwnershipStep);
    } else {
        resumeOwnershipStep();
    }
})();
